<script>
export default {
  name: 'JsonBoolean',
  functional: false,
  props: {
    jsonValue: Boolean,
    keyName: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
  },
  render (h) {
    const elements = [];
    elements.push(h('span', {
      class: {
        'jv-item': true,
        'jv-boolean': true,
      },
      domProps: {
        innerText: this.jsonValue.toString()
      }
    }));

    if (this.$scopedSlots['item-after']) {
      elements.push(h('span', { class: { 'jv-actions-holder': true }}, [h('span', this.$scopedSlots['item-after']({ data: { value: this.jsonValue, path: this.path, key: this.keyName, type: 'bool' } }), [])]));
    }

    if (this.$scopedSlots['item-before']) {
      elements.splice(0,0, h('span', { class: { 'jv-actions-holder': true }}, [h('span', this.$scopedSlots['item-before']({ data: { value: this.jsonValue, path: this.path, key: this.keyName, type: 'bool' } }), [])]));
    }

    return h('span', {}, elements)
  }
}
</script>
